import environmentConfig from "@/config/environment"

export const isDevEnv = environmentConfig.env === "development"
